// src/firebaseConfig.js
import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyD7br4iSWB3YEsSsPkap-gAT2BtKtj-Qr0",
  authDomain: "kiditou-2d30c.firebaseapp.com",
  databaseURL: "https://kiditou-2d30c.firebaseio.com",
  projectId: "kiditou-2d30c",
  storageBucket: "kiditou-2d30c.appspot.com",
  messagingSenderId: "263293565804",
  appId: "1:263293565804:web:06bfce8d397858effd5149",
  measurementId: "G-46FVTWLG5H"
};

export default firebase.initializeApp(firebaseConfig);
